import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EventDetailsContainerComponent } from "./event-details-container.component";
import { SharedModule } from "@shared/shared.module";
import { CustomerListModule } from "@shared/components/customer-list/customer-list.module";
import { MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatDividerModule } from "@angular/material/divider";
import { CustomerLegalEntitySelectModule } from "@shared/components/customer-legal-entity-select/customer-legal-entity-select.module";
import { NoItemsLayoutModule } from "@shared/components/no-items-layout/no-items-layout.module";
import { ModalWrapperModule } from "@shared/components/modal-wrapper/modal-wrapper.module";
import { CalendarModule } from "@shared/components/calendar/calendar.module";
import { MilestoneDetailsRowModule } from "@shared/components/milestone-details-row/milestone-details-row.module";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { FormsSharedModule } from "@shared/modules/forms-shared.module";
import { MatIconModule } from "@angular/material/icon";
import { SlidingPanelModule } from "@shared/components/sliding-panel/sliding-panel.module";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { InputWrapperModule } from "@shared/components/input-wrapper/input-wrapper.module";
import { PipesModule } from "src/app/shared/pipes/pipes.module";
import { CalendarEventsModule } from "./calendar-events/calendar-events.module";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MilestoneStatusDropdownComponent } from "src/app/standalone/milestone-status-dropdown/milestone-status-dropdown.component";

@NgModule({
	declarations: [EventDetailsContainerComponent],
	imports: [
		CommonModule,
		CustomerListModule,
		MatPaginatorModule,
		MatDividerModule,
		CustomerLegalEntitySelectModule,
		NoItemsLayoutModule,
		ModalWrapperModule,
		CalendarModule,
		MilestoneDetailsRowModule,
		MatRadioModule,
		FormsSharedModule,
		MatIconModule,
		SlidingPanelModule,
		MatButtonModule,
		MatDatepickerModule,
		MatInputModule,
		SharedModule,
		FlexLayoutModule,
		MatDialogModule,
		InputWrapperModule,
		PipesModule,
		CalendarEventsModule,
		MatTooltipModule,
		MilestoneStatusDropdownComponent
	],
	exports: [EventDetailsContainerComponent]
})
export class EventDetailsModule {}
